export default "__VITE_ASSET__Bk2vyD2B__"